import client from '@/api'

export default {
    getCurrentUserConfig(): Promise<account.TUserConfig> {
        return client.get<account.TUserConfig>({ url: '/common/auth/api/current' }).then((res: any) => res.userConfig )
    },

    logout(): Promise<void> {
        // logout은 api의 ResponseWrapper에 의해 정제된 데이터가 아니므로 HTTP 사용
        return client.get({ url: '/common/auth/api/logout' })
    },
}
